export default __webpack_public_path__ + "static/media/logoGrass.523df5b2.svg";